import { createRouter, createWebHistory } from "vue-router";

import Main from "../views/main.vue";
import store from "../store/index";

const routes = [
 
  {
    path: "/",
    name: "main",
    component: Main,
    children: [
      {
        path: "/",
        name: "Welcome",
        meta: {
          title: "安讯捷",
        },
        component: () => import("@/views/welcome.vue"),
      },
      {
        path: "/citySafe",
        name: "CitySafe",
        meta: {
          title: "城市安全服务平台",
        },
        component: () => import("@/views/citySafe.vue"),
      },
      {
        path: "/check",
        name: "Check",
        meta: {
          title: "智慧安检",
        },
        component: () => import("@/views/check.vue"),
      },
      {
        path: "/add",
        name: "Update",
        meta: {
          title: "应用信息更新",
        },
        component: () => import("@/views/updateApp.vue"),
      },
      {
        path: "/skipApp",
        name: "skipApp",
        meta: {
          title: "前往app",
        },
        component: () => import("@/views/skipApp.vue"),
      },
     
    ],
  },
  {
    path: "/appSet",
    name: "appSet",
    meta: {
      title: "权限设置",
    },
    component: () => import("@/views/appSet.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // if (to.fullPath != "/" && to.fullPath != "/add"&&to.fullPath != "/skipApp") {
  //   next({
  //     path: "/",
  //   });
  // } else {
    next();
  // }
});
export default router;
